module.exports = __webpack_public_path__ + "static/media/Decisions_Step3_Image5.eb6733fb.webp";